import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/subscription/prorate-seat-price/{nrOfSeats}', 'post'>;
type ResponseBody = OASOutput<O, '/api/subscription/prorate-seat-price/{nrOfSeats}', 'post'>;

type Params = {
  nrOfSeats: number;
};

type Result = {
  nextBillingDate: string | null;
  currency: string;
  creditCardBrand: string;
  lastFourDigits: string;
  priceIncrease: number;
  prorateCharge: number;
};

export const prorateSeatPriceFactory = (apiClient: ApiClient) => {
  const prorateSeatPrice = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/subscription/prorate-seat-price/{nrOfSeats}'].post(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      params: {
        nrOfSeats: input.nrOfSeats,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      nextBillingDate: response.nextBillingDate ?? null,
      currency: response.currency,
      creditCardBrand: response.creditCardBrand,
      lastFourDigits: response.lastFourDigits,
      priceIncrease: Number(response.priceIncrease),
      prorateCharge: Number(response.prorateCharge),
    };
  };

  return prorateSeatPrice;
};
